import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';

import { axios } from 'lib';

const createRole = (resource, id, { lotId, ...values }) => {
  return axios.post(`/api/${resource}/${id}/setup/lots/${lotId}/roles`, values);
};

export const useCreateRole = (resource, id, onSuccess) => {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: (values) => createRole(resource, id, values),
    onSuccess: () => {
      enqueueSnackbar('Role successfully added', { variant: 'success' });
      onSuccess();
    },
    onError: (error) => {
      enqueueSnackbar(error?.response?.data?.description || error?.message || 'Some error occured', {
        variant: 'error',
      });
    },
  });
};
